// extracted by mini-css-extract-plugin
export var errorIcon = "_nu-1";
export var nameLogo = "_nu-0";